import { Icon } from '@iconify/react';
import { CircularProgress, IconButton, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';
import { getReporteEmpaque } from '../../_apis_/dagpacket-oneRequest';
import { formatDateToRequest } from '../../utils/formatTime';
import useAuthUsers from '../../hooks/useAuthUsers';

const PedirReporteEmpaqueButton = ({ intervaloReporte, userIds }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const { currentUser } = useAuthUsers();

  const onDownload = (downloadLink) => {
    const link = document.createElement('a');
    link.download = `reporte.csv`;
    link.href = downloadLink;
    link.click();
  };

  const onGenerateReport = async () => {
    if (
      intervaloReporte.date_from === undefined ||
      intervaloReporte.date_to === undefined ||
      intervaloReporte.date_from === '' ||
      intervaloReporte.date_to === ''
    ) {
      return alert('Por favor, selecciona un rango de fechas');
    }

    const formattedDateFrom = formatDateToRequest(intervaloReporte.date_from);
    const formattedDateTo = formatDateToRequest(intervaloReporte.date_to);

    if (formattedDateFrom === '' || formattedDateTo === '') {
      return alert('Debe seleccionar un rango de fechas');
    }
    const endDate = new Date(formattedDateTo);
    endDate.setDate(endDate.getDate());
    const intervaloReporteMasUnDia = {
      date_from: formattedDateFrom,
      date_to: endDate.toISOString().substring(0, 10)
    };
    setIsLoading(true);
    try {
      // Extra validation
      if (currentUser.role !== 'almighty' && userIds === undefined) {
        throw new Error('No está autorizado para generar este reporte.');
      }

      const data = await getReporteEmpaque({
        ...intervaloReporteMasUnDia,
        ...(userIds && { userIds })
      });
      setIsLoading(false);
      setHasError(false);
      onDownload(data.link);
      console.log('downloaded');
    } catch (error) {
      // console.error({ error );
      setHasError(true);
      setIsLoading(false);
      if (error.message === 'No está autorizado para generar este reporte.') {
        alert(error.message);
      }
    }
  };

  return (
    <>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <>
          <Tooltip title="Generar reporte">
            <IconButton onClick={onGenerateReport}>
              <Icon icon="vscode-icons:file-type-excel" />
            </IconButton>
          </Tooltip>
          {hasError && (
            <Typography component="span" sx={{ color: 'red', fontSize: '12px' }}>
              Nada que mostrar por el momento
            </Typography>
          )}
        </>
      )}
    </>
  );
};

export default PedirReporteEmpaqueButton;
